// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ln-1";
export var messageSideRight = "_ln-2";
export var subscribeToBackInStockBubbleContainer = "_ln-0";